<template>
    <group-details :groupId="props.groupId">
        <div>
            <page-loading v-if="!billing"></page-loading>
            <template v-else>
                <group-billing-details
                    :teamId="props.teamId"
                    :groupId="props.groupId"
                    :billing="billing"
                    :isAdminOrOwner="isAdminOrOwner"
                />
            </template>
        </div>
    </group-details>
</template>

<script setup>
import GroupBillingDetails from './GroupBillingDetails.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import GroupDetails from '../form/GroupDetails.vue';
import { ref, onMounted } from 'vue';
import { groupBillingClient } from '~/services';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const billing = ref(null);
const isAdminOrOwner = Spark.isAdminOrOwner;
const toasted = useToasted();

onMounted(async () => {
    try {
        const response = await groupBillingClient.getBillingDetails(props.teamId, props.groupId);
        billing.value = response.data;
    } catch (error) {
        console.error('Failed to fetch billing details:', error);
        toasted.error('Failed to load billing details. Please try again.');
    }
});
</script>
